<div class="buscador-content w-100">
    <!-- <div class="buscador-cell text">{{text}}</div> -->
    <div class="buscador-cell">
            <input id="BSCT-inp-captura" type="text" class="m-auto" #buscadorSioCot matInput placeholder="Ejemplo: Mazda 3, Jetta, Aveo, etc." type="text" (keyup)="searchKeyUp($event)" (keydown)="handlerIgnored($event)"
                (focus)="txHandler(true)" (blur)="txHandler(false)" autocomplete="off" [(ngModel)]="strSearch">
            <!-- <button id="BSCT-btn-close" mat-button *ngIf="strSearch" matSuffix mat-icon-button aria-label="Clear" (click)="limpiarInput()">
                <mat-icon>close</mat-icon>
            </button>
            <button id="BSCT-btn-search" mat-button matSuffix mat-icon-button class="float-right">
                <mat-icon matSuffix>search</mat-icon>
            </button> -->
        <span *ngIf="searchResult" class="span-search">
            <ul *ngIf="searchEnabled == true" class="ul-search mat-elevation-z1">
                <li *ngFor="let search of searchResult;let idx = index;" [value]="idx" (click)="getDetalle(idx)" class="text-left" [class.selected]="search?.selected"
                    [innerHTML]="search.c3"></li>
                <li *ngIf="searchResult.length == 0" class="no-result">No hay resultados</li>
            </ul>
        </span>
    </div>
</div>